import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'src/constants'
import { whiteLabelService } from 'src/services'

export const useWhiteLabelOverrides = (
  whiteLabelId?: string | null,
  locale?: string,
  enabled = true,
) => {
  return useQuery(
    [QUERY_KEYS.GET_WHITE_LABEL_OVERRIDES, whiteLabelId, locale],
    () => (whiteLabelId && locale ? whiteLabelService.getOverrides(whiteLabelId, locale) : null),
    {
      enabled: Boolean(enabled && whiteLabelId && locale),
      keepPreviousData: true,
    },
  )
}


